/**
 * "Describe the job" — shared by the job-config-from-prompt edge function (schema, prompt,
 * validation, id resolution) and the Create Job dialog (placeholder, result type).
 * Not re-exported from the package root, so the root never imports this module back.
 */
import { ADAPTER_DEFINITIONS } from "../index.ts";
import type { PromptAdapterInfo } from "./prompt.ts";

export {
  GLOBAL_LISTING_TYPE_OPTIONS,
  GLOBAL_PROPERTY_TYPE_OPTIONS,
  GLOBAL_TIME_RANGE_OPTIONS,
} from "@repo/adapter-core";
export * from "./prompt.ts";
export * from "./resolve.ts";
export * from "./schema.ts";

/** The adapter enum offered to the model, derived from the registry. */
export const JOB_CONFIG_ADAPTER_SLUGS: string[] = ADAPTER_DEFINITIONS.map((a) => a.meta.slug);

export const JOB_CONFIG_PROMPT_ADAPTERS: PromptAdapterInfo[] = ADAPTER_DEFINITIONS.map((a) => ({
  slug: a.meta.slug,
  name: a.meta.name,
  supportedStates: a.meta.supportedStates,
  sourceType: a.meta.sourceType,
}));
